export default {
	state: {
		nextID: 0,
	},
	mutations: {
		incrementID(state) {
			state.nextID += 1;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/component-ids.store.js